<script>
import api from "@/helpers/api-rest/api.js";
import store from "@/state/store";
import qs from "qs";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import AppTextareaAi from "@/components/forms/AppTextareaAi.vue";
import { notifyValidationFailedAndFocusFirstInvalid } from "@/helpers/validations/vuelidateFormFeedback";

const isPdf = (value) => {
  return typeof value === "string" && value.toLowerCase().endsWith(".pdf");
};

export default {
  components: {
    AppTextareaAi,
  },
  props: {
    id: { type: String, default: "ModalContinuity" },
    essayId: { type: [Number, String] },
    centerId: { type: Number },
    continuity: {
      type: Object,
      default: () => {
        return {
          id: null,
          document_name: null,
        };
      },
    },
  },
  data() {
    return {
      isModalOpen: false,
      dataUser: [],
      selectOptionsTrackingStatus: [],
      selectOptionsActions: [],
      collapseOpen: [],
      loading: false,
      validateFile: false,
      downloadingAnexoVIII: false,
    };
  },
  computed: {
    modalTitle() {
      return this.continuity?.id ? "Editar continuidad" : "Añadir continuidad";
    },
    submitButtonText() {
      return this.continuity?.id ? "Guardar" : "Añadir";
    },
  },
  validations() {
    return {
      continuity: {
        new_objectives: { required },
        objectives_not_achieved: { required },
        document_path: this.validateFile ? { required, isPdf } : {},
      },
    };
  },
  methods: {
    formatDate(d = new Date()) {
      return `${String(d.getDate()).padStart(2, "0")}${String(
        d.getMonth() + 1
      ).padStart(2, "0")}${d.getFullYear()}${String(d.getHours()).padStart(
        2,
        "0"
      )}${String(d.getMinutes()).padStart(2, "0")}`;
    },
    showElement(
      roleId = [],
      show = true,
      showRechazado = true,
      showRenuncia = true
    ) {
      const role = store.getters["auth/role"];
      if (roleId.includes(role.id) && show && showRechazado && showRenuncia) {
        return true;
      }
      return false;
    },
    onFileChange(event) {
      this.file = event.target.files[0];
      this.continuity.document_name = this.formatDate() + "-" + this.file?.name;
      this.uploadFile(this.file, "continuities")
        .then((response) => {
          const file = response?.data?.data;
          this.continuity.document_path = file.path;
        })
        .catch((error) => {
          console.error("Error al cargar el archivo:", error);
        });
    },
    uploadFile(file, folder) {
      const formData = new FormData();
      formData.set("file", file);
      formData.append("path", folder);
      const config = { headers: { "content-type": "multipart/form-data" } };

      const apiEndpoint = `/api/v1/upload-file`;
      return api
        .post({ url: apiEndpoint, data: formData, config })
        .catch((error) => {
          this.loading = false;
          console.error("Error upload file:", error);
        });
    },
    toggleCollapse(index) {
      this.$set(this.collapseOpen, index, !this.collapseOpen[index]);
    },
    async downloadFileAnexoVIII() {
      if (this.downloadingAnexoVIII) return;
      
      this.downloadingAnexoVIII = true;
      try {
        const apiEndpoint = `/api/v1/anexo8`;
        const data = {
          continuity: this.continuity,
          essay_id: this.essayId,
          center_id: this.centerId,
        };

        const config = {
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
          },
        };

        const response = await api.post({
          url: apiEndpoint,
          data: data,
          baseURL: process.env.VUE_APP_API_HOST,
          config: config,
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = "Documento continuidad.pdf";
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error("Error al descargar el Documento:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Hubo un error al descargar el Documento. Por favor, inténtalo de nuevo.",
        });
      } finally {
        this.downloadingAnexoVIII = false;
      }
    },

    downloadFiles(fileName, folderID) {
      const params = {
        fileName: fileName,
        folderID: folderID,
      };

      const queryString = qs.stringify(params);
      const baseUrl = process.env.VUE_APP_API_HOST;
      const url = `${baseUrl}/download-drive?${queryString}`;
      window.open(url, "_blank");
    },

    createContinuity() {
      this.$v.$touch();
      console.log(this.$v.continuity);
      if (this.$v.$invalid) {
        notifyValidationFailedAndFocusFirstInvalid(this);
        this.loading = false;
        return;
      }
      this.loading = true;
      const apiEndpoint = `/api/v1/continuities`;
      this.continuity.essay_id = this.essayId;
      api
        .post({ url: apiEndpoint, data: this.continuity })
        .then((response) => {
          this.loading = false;
          const newContinuity = response?.data?.data;
          this.$emit("success", newContinuity);
          this.$bvModal.hide(this.id);
        })
        .catch((error) => {
          this.loading = false;
          console.error("Error al crear continuidad:", error);
        });
    },

    changeStatusContinuity(status) {
      this.continuity.status = status;
      this.updateContinuity();
    },

    updateContinuity() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        notifyValidationFailedAndFocusFirstInvalid(this);
        this.loading = false;
        return;
      }

      this.loading = true;
      const apiEndpoint = `/api/v1/continuities`;
      api
        .put({
          url: apiEndpoint,
          data: this.continuity,
          id: this.continuity.id,
        })
        .then((response) => {
          this.loading = false;
          const updatedContinuity = response?.data?.data;
          this.$emit("success", updatedContinuity);
          this.$bvModal.hide(this.id);
        })
        .catch((error) => {
          this.loading = false;
          console.error("Error al editar continuidad:", error);
        });
    },
    submitForm() {
      if (this.continuity?.id) {
        return this.updateContinuity();
      }
      return this.createContinuity();
    },
    cancelForm() {
      this.$bvModal.hide(this.id);
    },

    saveContinuity(status_user) {
      this.validateFile = false; // No validar file
      this.$v.$reset();
      this.continuity.status_user = status_user;
      this.submitForm();
    },
    addContinuity(status_user) {
      this.validateFile = true;
      this.$v.$reset();
      this.continuity.status_user = status_user;
      this.submitForm();
    },
    loadData() {
      this.$v.$reset();
    },
  },
};
</script>
<template>
  <div>
    <b-modal
      :id="id"
      :title="modalTitle"
      @shown="loadData"
      scrollable
      size="xl"
      no-close-on-backdrop
      no-close-on-esc
    >
      <!-- <b-modal :id="id" :hide-footer="!showElement([3])" :title="modalTitle" @shown="loadData" scrollable size="xl"> -->
      <template #default="{}">
        <form @submit.prevent="submitForm" enctype="multipart/form-data">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-12">
                  <h6>
                    Justificación de objetivos planificados no alcanzados
                    <span style="color: red">*</span>
                  </h6>
                  <div
                    v-if="
                      continuity?.essay?.essay_status_id == 7 ||
                      continuity?.essay?.essay_status_id == 4 ||
                      continuity?.essay?.essay_status_id == 6
                    "
                  >
                    <p class="text-muted">
                      {{ continuity?.objectives_not_achieved }}
                    </p>
                  </div>
                  <!-- <p v-if="showElement([1])" class="text-muted">
                      {{ continuity?.objectives_not_achieved }}
                  </p> -->
                  <div v-else class="form-group">
                    <app-textarea-ai
                      v-model="continuity.objectives_not_achieved"
                      :enable-ai="true"
                      :max-chars="5000"
                      :rows="3"
                      placeholder="Introduce justificación"
                      :textarea-class="{
                        'form-control': true,
                        'is-invalid':
                          $v.continuity.objectives_not_achieved.$error,
                      }"
                    ></app-textarea-ai>
                    <small class="text-muted"
                      >{{
                        continuity?.objectives_not_achieved?.length
                      }}/5000</small
                    >
                    <div
                      v-if="$v.continuity.objectives_not_achieved.$error"
                      class="invalid-feedback"
                    >
                      <div
                        v-if="!$v.continuity.objectives_not_achieved.required"
                      >
                        Este campo es requerido.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 mt-4">
                  <h6>
                    Justificación de objetivos nuevos
                    <span style="color: red">*</span>
                  </h6>
                  <div
                    v-if="
                      continuity?.essay?.essay_status_id == 7 ||
                      continuity?.essay?.essay_status_id == 4 ||
                      continuity?.essay?.essay_status_id == 6
                    "
                  >
                    <p class="text-muted">
                      {{ continuity?.new_objectives }}
                    </p>
                  </div>
                  <!-- <p v-if="showElement([1])" class="text-muted">
                      {{ continuity?.new_objectives }}
                  </p> -->
                  <div v-else class="form-group">
                    <app-textarea-ai
                      v-model="continuity.new_objectives"
                      :enable-ai="true"
                      :max-chars="5000"
                      :rows="3"
                      placeholder="Introduce justificación"
                      :textarea-class="{
                        'form-control': true,
                        'is-invalid': $v.continuity.new_objectives.$error,
                      }"
                    ></app-textarea-ai>
                    <small class="text-muted"
                      >{{ continuity?.new_objectives?.length }}/5000</small
                    >
                    <div
                      v-if="$v.continuity.new_objectives.$error"
                      class="invalid-feedback"
                    >
                      <div v-if="!$v.continuity.new_objectives.required">
                        Este campo es requerido.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  continuity?.essay?.essay_status_id != 7 &&
                  continuity?.essay?.essay_status_id != 4 &&
                  continuity?.essay?.essay_status_id != 6
                "
                class="row mt-4"
              >
                <div class="col-lg-12">
                  <b-alert show variant="warning">
                    <strong>Observaciones</strong><br />
                    <ul>
                      <li>
                        Antes de adjuntar el <strong>Documento</strong>,
                        primero debes generarlo
                        <a
                          href="javascript:void(0);"
                          @click.prevent="downloadFileAnexoVIII()"
                          :class="{ 'text-muted': downloadingAnexoVIII }"
                          :style="{ 
                            cursor: downloadingAnexoVIII ? 'not-allowed' : 'pointer',
                            pointerEvents: downloadingAnexoVIII ? 'none' : 'auto'
                          }"
                        >
                          <span
                            v-if="downloadingAnexoVIII"
                            class="spinner-border spinner-border-sm mr-1"
                            role="status"
                            aria-hidden="true"
                            style="width: 0.875rem; height: 0.875rem;"
                          ></span>
                          {{ downloadingAnexoVIII ? 'descargando' : 'aquí' }}
                        </a>
                      </li>
                      <li>
                        Si has completado los campos anteriores, también
                        aparecerán en el <strong>Documento</strong>
                      </li>
                    </ul>
                  </b-alert>
                </div>
                <div
                  v-if="
                    showElement([3], continuity?.essay?.essay_status_id != 7)
                  "
                  class="col-lg-6 mt-3"
                >
                  <h6>Adjuntar Documento <span style="color: red">*</span></h6>
                  <div class="form-group">
                    <div class="custom-file">
                      <input
                        id="inputFile"
                        type="file"
                        name="file"
                        class="custom-file-input"
                        @change="onFileChange"
                        accept="application/pdf"
                        :class="{
                          'is-invalid': $v.continuity.document_path.$error,
                        }"
                      />
                      <label class="custom-file-label" for="inputFile">{{
                        continuity.document_name || "Seleccione un archivo"
                      }}</label>
                      <div
                        v-if="$v.continuity.document_path.$error"
                        class="invalid-feedback"
                      >
                        <div v-if="!$v.continuity.document_path.required">
                          Este campo es requerido.
                        </div>
                        <div v-else-if="!$v.continuity.document_path.isPdf">
                          Solo se permiten archivos PDF.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="row mt-3">
                <div class="col-lg-12 mt-3">
                  <h6>Documento</h6>
                  <b-button
                    variant="info"
                    @click.prevent="
                      downloadFiles(
                        continuity?.document_name,
                        continuity?.essay?.folder_documents_id
                      )
                    "
                    ><i class="fas fa-file-download mr-2"></i>
                    Descargar</b-button
                  >
                </div>
              </div>
            </div>
          </div>
        </form>
      </template>
      <template #modal-footer="{}">
        <div class="d-flex justify-content-between w-100">
          <b-button
            v-if="
              showElement(
                [3],
                continuity?.essay?.essay_status_id != 7,
                continuity?.essay?.essay_status_id != 4,
                continuity?.essay?.essay_status_id != 6
              )
            "
            variant="primary"
            @click="saveContinuity('editando')"
            :disabled="loading"
            ><span
              class="spinner-border spinner-border-sm mr-2"
              role="status"
              aria-hidden="true"
              v-if="loading"
            ></span
            >Guardar continuidad</b-button
          >
          <div>
            <!-- <b-button v-if="showElement([3], continuity?.essay?.essay_status_id != 7)" class="mr-2" variant="success" @click="addContinuity()" :disabled="loading"><span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" v-if="loading"></span>Añadir continuidad</b-button> -->
            <b-button
              v-if="
                showElement(
                  [3],
                  continuity?.essay?.essay_status_id != 7,
                  continuity?.essay?.essay_status_id != 4,
                  continuity?.essay?.essay_status_id != 6
                )
              "
              class="mr-2"
              variant="success"
              @click="addContinuity('finalizado')"
              :disabled="loading"
              ><span
                class="spinner-border spinner-border-sm mr-2"
                role="status"
                aria-hidden="true"
                v-if="loading"
              ></span
              >Finalizar continuidad</b-button
            >
            <b-button
              v-if="showElement([1])"
              class="mr-2"
              variant="success"
              @click="changeStatusContinuity('aceptada')"
              :disabled="loading"
              ><span
                class="spinner-border spinner-border-sm mr-2"
                role="status"
                aria-hidden="true"
                v-if="loading && continuity.status == 'aceptada'"
              ></span
              >Aceptar</b-button
            >
            <b-button
              v-if="showElement([1])"
              class="mr-2"
              variant="danger"
              @click="changeStatusContinuity('rechazada')"
              :disabled="loading"
              ><span
                class="spinner-border spinner-border-sm mr-2"
                role="status"
                aria-hidden="true"
                v-if="loading && continuity.status == 'rechazada'"
              ></span
              >Rechazar</b-button
            >
            <b-button @click="cancelForm()">Cancel</b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
